// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/global.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FieldMask } from "../google/protobuf/field_mask";

export const protobufPackage = "carbon.portal.global";

export interface Globals {
  plantProfileModelId: string;
}

export interface UpdateGlobalsRequest {
  globals: Globals | undefined;
  updateMask: string[] | undefined;
}

function createBaseGlobals(): Globals {
  return { plantProfileModelId: "" };
}

export const Globals: MessageFns<Globals> = {
  encode(message: Globals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.plantProfileModelId !== "") {
      writer.uint32(10).string(message.plantProfileModelId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Globals {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobals();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plantProfileModelId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Globals {
    return {
      plantProfileModelId: isSet(object.plantProfileModelId)
        ? globalThis.String(object.plantProfileModelId)
        : isSet(object.plant_profile_model_id)
        ? globalThis.String(object.plant_profile_model_id)
        : "",
    };
  },

  toJSON(message: Globals): unknown {
    const obj: any = {};
    if (message.plantProfileModelId !== "") {
      obj.plantProfileModelId = message.plantProfileModelId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Globals>, I>>(base?: I): Globals {
    return Globals.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Globals>, I>>(object: I): Globals {
    const message = createBaseGlobals();
    message.plantProfileModelId = object.plantProfileModelId ?? "";
    return message;
  },
};

function createBaseUpdateGlobalsRequest(): UpdateGlobalsRequest {
  return { globals: undefined, updateMask: undefined };
}

export const UpdateGlobalsRequest: MessageFns<UpdateGlobalsRequest> = {
  encode(message: UpdateGlobalsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.globals !== undefined) {
      Globals.encode(message.globals, writer.uint32(10).fork()).join();
    }
    if (message.updateMask !== undefined) {
      FieldMask.encode(FieldMask.wrap(message.updateMask), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateGlobalsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateGlobalsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.globals = Globals.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updateMask = FieldMask.unwrap(FieldMask.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateGlobalsRequest {
    return {
      globals: isSet(object.globals) ? Globals.fromJSON(object.globals) : undefined,
      updateMask: isSet(object.updateMask)
        ? FieldMask.unwrap(FieldMask.fromJSON(object.updateMask))
        : isSet(object.update_mask)
        ? FieldMask.unwrap(FieldMask.fromJSON(object.update_mask))
        : undefined,
    };
  },

  toJSON(message: UpdateGlobalsRequest): unknown {
    const obj: any = {};
    if (message.globals !== undefined) {
      obj.globals = Globals.toJSON(message.globals);
    }
    if (message.updateMask !== undefined) {
      obj.updateMask = FieldMask.toJSON(FieldMask.wrap(message.updateMask));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateGlobalsRequest>, I>>(base?: I): UpdateGlobalsRequest {
    return UpdateGlobalsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateGlobalsRequest>, I>>(object: I): UpdateGlobalsRequest {
    const message = createBaseUpdateGlobalsRequest();
    message.globals = (object.globals !== undefined && object.globals !== null)
      ? Globals.fromPartial(object.globals)
      : undefined;
    message.updateMask = object.updateMask ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
